import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { GenerateUniqueGUID } from "../Shared/Utility";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { showErrorMessage } from "../Shared/Toast";

const PTDragDropUpload = ({
  PTFilesList: initialFiles = [],
  ObjectType = 0,
  ObjectID = 0,
  MaxNumberOfFiles = 1000,
  CanEditFiles = true,
  UploadType = 2,
  CanSendVoiceNotes = false,
  onResponse,
}: any) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  const [PTFilesList, setPTFilesList] = useState<any[]>([]);
  const [FilesList, setFilesList] = useState<any[]>([]);

  const [ImageVideoURL, setImageVideoURL] = useState("");
  const [cacheBuster, setCacheBuster] = useState(Date.now());

  const [showModal, setshowModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [uploadFile, setuploadFile] = useState(false);
  const [firstTime, setfirstTime] = useState(true);

  /* -------------------- LOAD EXISTING FILES -------------------- */
  useEffect(() => {
    if ((ObjectType === 1 || ObjectType === 20) && ObjectID > 0) {
      loadFiles();
    }
  }, [ObjectType, ObjectID]);

  const loadFiles = async () => {
    const res = await axiosAuth.post(
      AppContext.APIURL +
        "api/MNVQuoteAdmin/GetAttachmentDataByObjectTypeIDObjectID",
      {
        ObjectType,
        ObjectID,
        SizeType: UploadType,
      },
    );

    const files = res.data[0].map((f: any) => ({
      ObjectType,
      ObjectID,
      Name: f.Title,
      Size: Number(f.Description),
      Type: f.Tags,
      FileURL: f.AttachmentURL,
      FullFileURL: f.AttachmentURL,
      FileURLDisplay: AppContext.GetFileIconToDisplay(f.AttachmentURL),
    }));

    setPTFilesList(files);
    emitResponse(files);
  };

  useEffect(() => {
    if (firstTime == false) {
      UploadAndSavePartnerFilesInArray1();
    }
  }, [uploadFile]);

  const prepareFiles = (files: any[]) => {
    setfirstTime(false);
    const list = [...FilesList, ...files];
    setFilesList(list);
    setuploadFile(!uploadFile);
  };

  const UploadAndSavePartnerFilesInArray1 = async () => {
    setLoading(true);
    let updatedPTFilesList = [] as any;
    for (let i = 0; i < FilesList.length; i++) {
      if (FilesList.length >= MaxNumberOfFiles) {
        if (MaxNumberOfFiles === 1) {
          showErrorMessage(
            `You are only allowed to add upto ${MaxNumberOfFiles} file only, Rest of the files are discarded.`,
          );
        } else if (MaxNumberOfFiles > 1) {
          showErrorMessage(
            `You are only allowed to add upto ${MaxNumberOfFiles} files only, Rest of the files are discarded.`,
          );
        }

        break;
      } else {
        const file = FilesList[i];
        const fileNewName = `${GenerateUniqueGUID()}-${
          file.Name ? file.Name : file.name
        }`;

        // Remove spaces
        const replaceSpaces = fileNewName.replace(/\s/g, "");

        const filePath = `Uploads/${replaceSpaces}`;

        const fileToUpload = FilesList[i];
        

        if (fileToUpload) {
          // const fileToUpload = fileInputRef.current.files[i];

          if (isFileSizeLesserThanAllowedMB(fileToUpload.size, 500)) {
            try {
              const formData = new FormData();
              formData.append("file", fileToUpload, replaceSpaces);
              formData.append("UploadType", UploadType.toString());

              let url = `${AppContext.APIURL}FileUploader/UploadFile_AdminS3`;
              try {
                await axiosAuth.post(url, formData).then((response: any) => {
                  console.log(response.data);
                  
                  if (response.data[0]?.Status !== 1) {
                    showErrorMessage(response.data[0]?.Message); // replace with toast if needed
                  }

                  // Angular: if (Default.FileUploaderStatus == 1)
                  if (response.data[0]?.Status === 1) {
                    var fileURL = response.data[0].FileURL;
                    if(fileURL.indexOf('https://')>-1)
                    {
                      fileURL= fileURL;
                    }
                    else
                      fileURL = AppContext.APIURL + filePath;
                    updatedPTFilesList.push({
                      ObjectType,
                      ObjectID,
                      Name: fileToUpload.name,
                      Size: fileToUpload.size,
                      Type: fileToUpload.type,
                      FileURL: fileURL,
                      FileURLDisplay: AppContext.GetFileIconToDisplay(
                        fileURL,
                      ),
                    });
                  }
                });
              } catch (error) {
                throw error;
              }
            } catch (error) {
              console.error(error);
              return 0;
            }
          } else {
            showErrorMessage(
              "You are allowed to upload files upto only 500 MBs.",
            );
            return 0;
          }
        }
      }
    }

    let allFiles = [...PTFilesList, ...updatedPTFilesList];
    setPTFilesList(allFiles);
    emitResponse(allFiles);

    setLoading(false);

    // Angular: document.getElementById("PTFileUploaderInput").value = ""
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setFilesList([]);
  };

  const isFileSizeLesserThanAllowedMB = (
    sizeInBytes: number,
    maxMB: number,
  ) => {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return sizeInMB <= maxMB;
  };

  const removeFile = (index: number) => {
    const updated = PTFilesList.filter((_, i) => i !== index);
    setPTFilesList(updated);
    emitResponse(updated);
  };

  const emitResponse = (list: any[]) => {
    onResponse?.({
      ObjectType,
      ObjectID,
      PTFilesList: list,
    });
  };
  const isVideoType = (path: string) =>
    ["mp4", "avi", "mkv", "mov", "wmv", "flv", "m4v", "ogv", "vob"].includes(
      path?.split(".").pop()?.toLowerCase() || "",
    );

  const isDocType = (path: string) =>
    ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv", "zip", "zipx"].includes(
      path?.split(".").pop()?.toLowerCase() || "",
    );

  const showMedia = (url: string) => {
    setImageVideoURL(url);
    setCacheBuster(Date.now());
    setshowModal(true);
    setTimeout(() => {
      videoRef.current?.load();
      videoRef.current?.play();
    }, 100);
  };

  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      const mimeType = MediaRecorder.isTypeSupported("audio/webm")
        ? "audio/webm"
        : "audio/mp4";

      const mediaRecorder = new MediaRecorder(stream, { mimeType });
      mediaRecorderRef.current = mediaRecorder;

      const chunks: BlobPart[] = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: mimeType });
        setRecordedBlob(blob);

        // Create File object so your existing uploader works
        const audioFile = new File(
          [blob],
          `Voice-${GenerateUniqueGUID()}.webm`,
          { type: mimeType },
        );

        prepareFiles([audioFile]); // 🔥 Reuse your existing upload logic

        // reset timer
        setRecordingTime(0);
        if (timerRef.current) clearInterval(timerRef.current);
      };

      mediaRecorder.start();
      setIsRecording(true);

      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } catch (error) {
      showErrorMessage("Microphone permission denied.");
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };
  const isAudioType = (path: string) =>
    ["mp3", "wav", "webm", "m4a", "ogg", "aac"].includes(
      path?.split(".").pop()?.toLowerCase() || "",
    );
  /* -------------------- JSX -------------------- */
  return (
    <div className="drag-drop-main inline-block-d width-100">
      {loading && <LoadingAnimation />}
      {CanEditFiles && PTFilesList.length < MaxNumberOfFiles && (
        <>
          <div
            className="drag-drop p-relative drag-custom-drop text-center"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              prepareFiles(Array.from(e.dataTransfer.files));
            }}
          >
            <div className="txt-drag flex-dj">Drag and drop file here or</div>
            {/* <div className="btn-browse flex-dj">
            <a className="btn-secondary flex-daj">Browse for file</a>
          </div> */}
            <input
              ref={fileInputRef}
              type="file"
              multiple
              onChange={(e) => prepareFiles(Array.from(e.target.files || []))}
            />
          </div>

          {CanSendVoiceNotes == true &&<div className="voice-recorder-container">
            {isRecording && (
              <div className="recording-timer">
                🔴 {formatTime(recordingTime)}
              </div>
            )}

            {!isRecording ? (
              <button
                type="button"
                onClick={startRecording}
                className={`mic-button ${isRecording ? "recording" : ""}`}
              >
                🎤
              </button>
            ) : (
              <button
                type="button"
                onClick={stopRecording}
                className={`mic-button ${isRecording ? "recording" : ""}`}
              >
                🎤
              </button>
            )}
          </div>}
        </>
      )}

      <div className="contact-attachments wrap-flex">
        {PTFilesList.map((img, index) => (
          <div key={index} className="remove--image2">
            {!isDocType(img.FileURL) ? (
              <a
                className="p-relative"
                onClick={() => showMedia(img.FullFileURL)}
              >
                <img
                  src={img.FileURLDisplay}
                  width={100}
                  height={100}
                  className="max-minimg"
                />
              </a>
            ) : (
              <a className="p-relative" href={img.FullFileURL} download>
                <img
                  src={img.FileURLDisplay}
                  width={100}
                  height={100}
                  className="max-minimg"
                />
              </a>
            )}

            {CanEditFiles && (
              <a onClick={() => removeFile(index)} className="cross-abs">
                {" "}
                <img
                  className=""
                  src="https://dft8zj8i6wy63.cloudfront.net/mnv/images/cross.svg"
                  alt="delete"
                  width="9"
                  height="17"
                />
              </a>
            )}
          </div>
        ))}
      </div>

      {/* {ImageVideoURL && (
        <div className="modal">
          {isVideoType(ImageVideoURL) ? (
            <video ref={videoRef} controls width="700">
              <source src={`${ImageVideoURL}?v=${cacheBuster}`} />
            </video>
          ) : (
            <img src={ImageVideoURL} width="700" />
          )}
        </div>
      )} */}

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner md-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0"></h3>
                <a className="close-help" onClick={() => setshowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              {ImageVideoURL && (
                <div className="grid-d flex-gap10 video-controls mt-20">
                  {isVideoType(ImageVideoURL) ? (
                    <video ref={videoRef} controls width="700">
                      <source src={`${ImageVideoURL}?v=${cacheBuster}`} />
                    </video>
                  ) : isAudioType(ImageVideoURL) ? (
                    <audio controls style={{ width: "700px" }}>
                      <source src={`${ImageVideoURL}?v=${cacheBuster}`} />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    <img src={ImageVideoURL} width="700" />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PTDragDropUpload;
